import React, { FC } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const Loading: FC<{ loading?: boolean }> = ({ loading = true }) => {
  return (
    loading && (
      <div className="loading">
        <div className="lds-ripple">
          <div className="icon">
            <img alt="Clik" src={`${process.env.PUBLIC_URL}/images/logo/logo.svg`} />
          </div>
          <div className="rotate"></div>
        </div>
      </div>
    )
  );
};

Loading.propTypes = {
  loading: PropTypes.bool,
};

Loading.defaultProps = {
  loading: false,
};

export default Loading;
